import React from "react";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";
import { ScheduleRemark } from "../services/apiService";
import {
  getRemarkChipDisplay,
  getRemarkTooltip,
} from "../utils/scheduleRemarkUtils";

const MAX_VISIBLE_CHIPS = 2;

interface ScheduleRemarkChipsProps {
  remarks: ScheduleRemark[];
  className?: string;
  idPrefix?: string;
}

export const ScheduleRemarkChips: React.FC<ScheduleRemarkChipsProps> = ({
  remarks,
  className = "",
  idPrefix = "remark",
}) => {
  if (remarks.length === 0) {
    return null;
  }

  const visibleRemarks = remarks.slice(0, MAX_VISIBLE_CHIPS);
  const hiddenRemarks = remarks.slice(MAX_VISIBLE_CHIPS);

  const overflowTooltip = hiddenRemarks
    .map((remark) => getRemarkTooltip(remark))
    .join("\n\n");

  const overflowDisplay = hiddenRemarks[0]
    ? getRemarkChipDisplay(hiddenRemarks[0])
    : getRemarkChipDisplay(visibleRemarks[0]);

  return (
    <span
      className={`inline-flex align-items-center gap-1 flex-nowrap ${className}`}
      style={{ pointerEvents: "auto", verticalAlign: "middle" }}
      onClick={(e) => e.stopPropagation()}
    >
      {visibleRemarks.map((remark) => {
        const chipId = `${idPrefix}-schedule-remark-${remark.id}`;
        const display = getRemarkChipDisplay(remark);
        return (
          <React.Fragment key={remark.id}>
            <Tooltip target={`#${chipId}`} content={display.tooltip} />
            <Tag
              id={chipId}
              rounded
              icon={display.icon}
              value={display.chipText}
              className={`schedule-remark-chip schedule-remark-chip--${display.variant}`}
            />
          </React.Fragment>
        );
      })}
      {hiddenRemarks.length > 0 && (
        <>
          <Tooltip
            target={`#${idPrefix}-schedule-remark-overflow`}
            content={overflowTooltip}
          />
          <Tag
            id={`${idPrefix}-schedule-remark-overflow`}
            rounded
            icon={overflowDisplay.icon}
            value={`+${hiddenRemarks.length}`}
            className={`schedule-remark-chip schedule-remark-chip--${overflowDisplay.variant}`}
          />
        </>
      )}
    </span>
  );
};
